import { render } from "./ShowcaseComp.vue?vue&type=template&id=5791907b&scoped=true"
import script from "./ShowcaseComp.vue?vue&type=script&lang=js"
export * from "./ShowcaseComp.vue?vue&type=script&lang=js"

import "./ShowcaseComp.vue?vue&type=style&index=0&id=5791907b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5791907b"]])

export default __exports__